import { render, staticRenderFns } from "./CompanyMultiRestaurantTabCreditUsers.vue?vue&type=template&id=2b5b3a1e"
import script from "./CompanyMultiRestaurantTabCreditUsers.vue?vue&type=script&lang=js"
export * from "./CompanyMultiRestaurantTabCreditUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports